export default __webpack_public_path__ + "static/media/Homescreen-04.3fb11925.jpg";